﻿import { _fetch } from '@global/js/fetch-wrapper';

const getVerificationToken = function() {
  return document.querySelector("input[name='__RequestVerificationToken']")
    .value;
};

const uniqueCharCount = function(str) {
  return [...str].reduce(
    (acc, curr) => (acc.includes(curr) ? acc : acc + curr),
    ""
  ).length;
};

const scrub = function(str) {
  return str
    .toLowerCase()
    .replace(/\$/g, "s")
    .replace(/0/g, "o")
    .replace(/!/g, "i")
    .replace(/3/g, "e")
    .replace(/@/g, "a")
    .replace(/1/g, "i");
};

export function ajax(url, data) {
  return _fetch.post(
    url,
    data,
    { headers: { 'x-verification-token': getVerificationToken() } }
  );
}

export function isValidPassword(pwd) {
  return (
    pwd &&
    pwd.length >= 8 &&
    uniqueCharCount(pwd) >= 4 &&
    scrub(pwd).indexOf("employee") == -1 &&
    scrub(pwd).indexOf("navigator") == -1 &&
    scrub(pwd).indexOf("eenav") == -1
  );
}

export function logError(error) {
  if (window.console && window.console.log) {
    window.console.log("Error: " + error);
  }
}

